module.exports = __webpack_public_path__ + "img/id-wrong-dark.e924a069.png";